__webpack_require__.p = "/Card-application/";